import React, { Component } from 'react';
import {Icon} from 'react-fa'
class SidebarFeedBack extends Component {

  constructor() {
    super();
    // Initial scroll position
    this.state = {
      scrollPosition: this.getWindowScrollTop(),
      style : null
    };

    // Bind handlers
    this.handleInterval = this.handleInterval.bind(this);
    this.handleRequestAnimationFrame = this.handleRequestAnimationFrame.bind(this);
  }

  componentWillMount() {
    // 50 times per second, change to your needs
    const INTERVAL = 20;
    this.intervalID = setInterval(this.handleInterval, INTERVAL);
  }

  componentDidMount(){

    setTimeout(()=>{
      const wheight = window.innerHeight
      if(this.getWindowScrollTop()>wheight/2){
        if(this.state.style !== "orange"){
          this.setState({
            style: "orange",
            scrollPosition : this.getWindowScrollTop()
          });
        }
      }else if(this.state.style !== "white"){
        this.setState({
          style: "white",
          scrollPosition : this.getWindowScrollTop()
        });
      }
    },80)
  }

  componentWillUnmount() {
  // Remove and reset interval/animationFrame
  clearInterval(this.intervalID);
  cancelAnimationFrame(this.requestID);
  this.requestID = null;
  this.intervalID = null;
  }

  getWindowScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop;
  }

  handleInterval() {
    cancelAnimationFrame(this.requestID);
    this.requestID = requestAnimationFrame(this.handleRequestAnimationFrame);
  }

  handleRequestAnimationFrame() {
    const { scrollPosition } = this.state;
    const newScrollPosition = this.getWindowScrollTop();

    // Update the state only when scroll position is changed
    if (newScrollPosition !== scrollPosition) {

      const wheight = window.innerHeight
      if(scrollPosition>wheight/2){
        if(this.state.style !== "orange"){
          this.setState({
            style: "orange",
          });
        }
      }else if(this.state.style !== "white"){
        this.setState({
          style: "white",
        });
      }
      this.setState({
        scrollPosition: newScrollPosition,
      });
    }
  }


  render() {
    const { scrollPosition } = this.state;
   return (
      <div className="sidebar">
        <ul>
          <li><a target="_blank" href="https://www.instagram.com/agence_bakasable/" className={this.state.style} > <Icon name="instagram" /></a></li>
          <li><a target="_blank" href="https://twitter.com/bakasable?lang=fr" className={this.state.style} > <Icon name="twitter" /></a></li>
          <li><a target="_blank" href="https://www.facebook.com/bksbl/" className={this.state.style} > <Icon name="facebook-f" /></a></li>
          <li><a target="_blank" href="https://www.behance.net/bakasable" className={this.state.style} > <Icon name="behance" /></a></li>
        </ul>
      </div>
    )
  }

}

export default SidebarFeedBack;



// WEBPACK FOOTER //
// ./src/client/components/sidebarFeedBack.js